<template>
  <div class="provider-select">
    <v-select
      :id="getProviderHtmlId()"
      ref="providers"
      v-model="selectedProviders"
      :items="providers"
      item-title="name"
      item-value="name"
      :menu-props="{ maxHeight: '400' }"
      placeholder="Add Approved Providers"
      multiple
      chips
      closable-chips
      return-object
      variant="underlined"
      color="primary"
      density="default"
      :disabled="!formControlEnabled"
      testing-id="selectedProviders"
      @update:model-value="changeSelectedProvider"
    >
      <template #chip="data">
        <v-chip
          v-bind="data.props"
          :id="getRemoveProvidersId()"
          closable
          density="comfortable"
          size="large"
          :class="{
            'chip--select-multi': data.item.raw.answer,
            'chip--select-multi light-orange-chip': !data.item.raw.answer,
            'pa-4': true
          }"
        >
        </v-chip>
      </template>
      <template #item="data">
        <v-list-item :class="itemClass(data.item)" density="comfortable" v-bind="data.props">
          <template #prepend="{ isSelected }">
            <v-list-item-action>
              <v-checkbox-btn
                :model-value="isSelected"
                color="primary"
                density="compact"
                @update:model-value="(val) => (data.props.isSelected = val)"
              ></v-checkbox-btn>
            </v-list-item-action>
          </template>
        </v-list-item>
      </template>
    </v-select>
  </div>
</template>

<script>
import * as types from '@/store/mutationTypes';
import { mapState } from 'vuex';

export default {
  name: 'ProviderSelect',

  props: {
    categoryName: {
      type: String,
      required: false,
      default: ''
    },
    formControlEnabled: {
      type: Boolean,
      default: true
    }
  },

  emits: ['changeProviderDone'],

  data() {
    return {
      providers: [],
      selectedProviders: []
    };
  },
  computed: {
    ...mapState({
      allProviders: (state) => state.common.allProviders
    }),
    itemClass() {
      return (item) => {
        return item.raw.answer ? 'provider-list-item' : 'provider-list-item light-orange-chip';
      };
    }
  },
  watch: {
    allProviders: {
      handler() {
        this.providers = this.$store.getters['common/getProvidersByCategory'](this.categoryName);
      },
      deep: true
    }
  },
  mounted() {
    const selectedProviders = this.$store.getters['common/getSelectedProvidersByCategory'](
      this.categoryName
    );
    this.providers = this.$store.getters['common/getProvidersByCategory'](this.categoryName);
    this.selectedProviders = selectedProviders;
    this.$emit('changeProviderDone');
  },
  methods: {
    async changeRiskCategoryCompleteChecklist(tlrcName) {
      // tlrc stands for: top level risk category
      const frcs = [[tlrcName]];
      this.$store.commit(types.COMMON_SET_CHECKLIST_FETCH_ACTION_IN_PROGRESS, true);
      const argHash = {
        store: this.$store,
        queryParam: this.$route.query,
        frcs
      };
      const response = await this.$app.stbApiAdapter.getCompleteChecklist(argHash);
      this.$store.commit(types.COMMON_SET_CE_COMMIT_OID, response.ceCommitOid);
      this.$store.commit(types.COMMON_SET_CHECKLIST_FETCH_ACTION_IN_PROGRESS, false);
      const risk = this.$store.getters['common/getTlrc'](tlrcName);
      if (risk && risk.name) {
        const result = [
          {
            checklist: response.optional.find((o) => o.title === this.categoryName)
          }
        ];
        this.$store.commit(types.COMMON_SET_RISK_COMPLETE_CHECKLIST, {
          risk,
          result
        });
      }
    },
    getProviderHtmlId() {
      const id = this.categoryName ? this.categoryName.replace(/ /g, '') : '';
      return `select${id}Provider`;
    },
    changeSelectedProvider() {
      const selectedProviderNames = this.selectedProviders.map((provider) => provider.name);
      this.$store.dispatch('common/setExcursionSelectedProviders', {
        categoryName: this.categoryName,
        selectedProviderNames,
        providers: this.providers
      });
      if (this.categoryName === 'Outdoor Education Providers') {
        this.changeRiskCategoryCompleteChecklist(this.categoryName, selectedProviderNames);
      }
      this.$emit('changeProviderDone');
    },
    getRemoveProvidersId() {
      const id = this.categoryName ? this.categoryName.replace(/ /g, '') : '';
      return `providers--remove-${id}-provider--selection`;
    }
  }
};
</script>

<style scoped>
.provider-select :deep(.v-select--chips .v-chip__close) {
  color: rgb(0, 0, 0, 0.6);
}

.light-orange-chip {
  background: #f8eee3;
}
</style>
